<div class="preview-cc-content" [class.empty]="empty">
  <div #cc class="cc-content"></div>
</div>